'use strict';

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Declaration = require('../declaration');

var ColorAdjust = function (_Declaration) {
    _inherits(ColorAdjust, _Declaration);

    function ColorAdjust() {
        _classCallCheck(this, ColorAdjust);

        return _possibleConstructorReturn(this, _Declaration.apply(this, arguments));
    }

    /**
     * Change property name for WebKit-based browsers
     */
    ColorAdjust.prototype.prefixed = function prefixed(prop, prefix) {
        return prefix + 'print-color-adjust';
    };

    /**
     * Return property name by spec
     */


    ColorAdjust.prototype.normalize = function normalize() {
        return 'color-adjust';
    };

    return ColorAdjust;
}(Declaration);

Object.defineProperty(ColorAdjust, 'names', {
    enumerable: true,
    writable: true,
    value: ['color-adjust', 'print-color-adjust']
});


module.exports = ColorAdjust;


//////////////////
// WEBPACK FOOTER
// ./~/autoprefixer/lib/hacks/color-adjust.js
// module id = 347
// module chunks = 79718873386587